import React from 'react';
import { Table, Dropdown, Label } from 'semantic-ui-react';

const ListRow = (actionHandler, COLOR_CODE_MAPPINGS) => marketFactor => {
  const rowMenuOptions = [
    { key: 1, text: 'Edit', value: 'Edit' },
    { key: 2, text: 'Delete', value: 'Delete' },
  ];

  const {
    id, title, description, color, status,
  } = marketFactor;

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, marketFactor);
  };

  return (
    <Table.Row key={id}>
      <Table.Cell>{title}</Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>
        <Label circular color={COLOR_CODE_MAPPINGS[color]} key={color} />
      </Table.Cell>
      <Table.Cell>{status}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
